import { atom } from "jotai";

export const editAtom = atom<string | null>(null);
